import React from 'react';

/**
 * Lightweight, high-performance loading fallback displayed during 
 * dynamic route chunk downloads (React.lazy / Suspense).
 */
export const RouteLoadingFallback = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] w-full px-4 py-12">
      <div className="relative flex items-center justify-center">
        {/* Outer glowing pulsing ring */}
        <div className="w-14 h-14 rounded-full border-4 border-emerald-500/20 animate-ping absolute" />
        {/* Spinning indicator */}
        <div className="w-12 h-12 rounded-full border-4 border-emerald-500/30 border-t-emerald-500 animate-spin" />
      </div>
      <p className="mt-4 text-sm font-medium text-gray-400 tracking-wide animate-pulse">
        Loading view...
      </p>
    </div>
  );
};

export default RouteLoadingFallback;
